<template lang="pug">
.description_detail.i_mlr_auto
  .container.i_mt_5
    .row
      .col-12.text-center
        h5 {{ table.Detail_area01_Title }}
    .row.i_mt_4
      .col-12
        img.table(:src="table.Detail_area01_Image")
      .col-12
        svg-icon.i_mt_2(iconClass="check_oval", className="check_oval")
        span.check_text.i_ml_1 該項保單之主要承保項目，不需另外加保。承保時需以保單條款為主。
    .row.i_mt_6.btns.d-none.d-md-flex.justify-content-between.i_ptb_4.i_mlr_4
      a.btn_round.btn_border_blue_ci(
        v-if="table.Detail_area01_Btn01_URL != null && table.Detail_area01_Btn01_URL != ''",
        :href="table.Detail_area01_Btn01_URL",
        target="_blank"
      ) {{ table.Detail_area01_Btn01_Title }}
      a.btn_round.btn_border_blue_ci(
        v-if="table.Detail_area01_Btn02_URL != null && table.Detail_area01_Btn02_URL != ''",
        :href="table.Detail_area01_Btn02_URL",
        target="_blank"
      ) {{ table.Detail_area01_Btn02_Title }}
      a.btn_round.btn_border_blue_ci(
        v-if="table.Detail_area01_Btn03_URL != null && table.Detail_area01_Btn03_URL != ''",
        :href="table.Detail_area01_Btn03_URL",
        target="_blank"
      ) {{ table.Detail_area01_Btn03_Title }}
      router-link.btn_round(
        v-if="true",
        tag="a",
        :to="{ name: 'CustomerServiceContactUs' }"
      ) 聯絡我們
      .btn_round.btn_yellow(
        v-if="table.WebInsured == 1",
        @click="toUrl(table.WebInsuredUrl)"
      ) 網路投保
    .row.i_mt_6.i_mlr_4.d-none.d-md-block
      p.i_body_l.note {{ table.Detail_area01_Note }}
  .container-fluid.bg_blue.i_ptb_8.i_mt_6.d-md-none
    .container
      .row.btns_sm_1.d-flex.justify-content-between
        a.btn_round.btn_border_blue_ci(
          :href="table.Detail_area01_Btn01_URL",
          target="_blank"
        ) {{ table.Detail_area01_Btn01_Title }}
        a.btn_round.btn_border_blue_ci(
          :href="table.Detail_area01_Btn02_URL",
          target="_blank"
        ) {{ table.Detail_area01_Btn02_Title }}
        a.btn_round.btn_border_blue_ci(
          :href="table.Detail_area01_Btn03_URL",
          target="_blank"
        ) {{ table.Detail_area01_Btn03_Title }}

      .row.i_mt_6
        p.i_body_l.note {{ table.Detail_area01_Note }}
      .row.btns_sm_2.justify-content-center
        router-link.btn_round(
          v-if="true",
          tag="a",
          :to="{ name: 'CustomerServiceContactUs' }"
        ) 聯絡我們
        .btn_round.btn_yellow(
          v-if="table.WebInsured == 1",
          @click="toUrl(table.WebInsuredUrl)"
        ) 網路投保
</template>

<script>
export default {
  name: "Table",
  props: {
    table: Object,
  },
  methods: {
    toUrl(url) {
      window.open(url);
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/style/product/description/table";
</style>
